import React from 'react'

const WomenPage = () => {
  return (
    <div>WomenPage</div>
  )
}

export default WomenPage